import React, { useEffect, useState } from 'react';
import { Button, Image, Modal, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import type { RcFile, UploadProps } from 'antd/es/upload';
import type { UploadFile } from 'antd/es/upload/interface';
import VehicleFile from '../../core/models/VehicleFile';

interface IProps {
  fileType: string;
  onChange: (files: VehicleFile[]) => void;
  reset: boolean;
  maxPhotos: number;
}

const getBase64 = async (file: RcFile): Promise<string> =>
  // eslint-disable-next-line @typescript-eslint/return-await
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const UploadVehiclePhotos: React.FC<IProps> = ({ fileType, onChange, reset, maxPhotos }) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  useEffect(() => {
    setFileList([]);
  }, [reset]);

  const handleCancel = (): void => setPreviewOpen(false);

  const handlePreview = (file: UploadFile): void => {
    if (!file.url && !file.preview) {
      void (async () => {
        file.preview = await getBase64(file.originFileObj as RcFile);

        setPreviewImage(file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name ?? file.url!.substring(file.url!.lastIndexOf('/') + 1));
      })();
    }
    setPreviewImage(file.url ?? (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name ?? file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  const uploadUrl = process.env.REACT_APP_AUTOSTREAM_API
    ? `${process.env.REACT_APP_AUTOSTREAM_API}/files/vehicle/img`
    : '';

  const props: UploadProps = {
    name: 'file',
    action: uploadUrl,
    headers: {
      authorization: `Bearer ${localStorage.getItem('accessToken') ?? ''}`,
    },
    listType: 'picture-card',
  };

  const handleChange: UploadProps['onChange'] = ({ file, fileList }) => {
    setFileList(fileList.slice());

    if (file.status === 'done' || file.status === 'removed') {
      onChange(
        fileList
          .filter((file) => file.status === 'done')
          .map((file) => ({
            filePath: file?.response?.filePath,
            fileName: file?.response?.fileName,
            isInspectionFile: false,
            photoNo: 0,
          })),
      );
    }
  };

  return (
    <>
      <Upload
        {...props}
        onChange={handleChange}
        onPreview={handlePreview}
        fileList={fileList}
        maxCount={maxPhotos}
        multiple
      >
        {fileList.length < maxPhotos && <Button icon={<UploadOutlined />}></Button>}
      </Upload>
      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
        <Image width={'100%'} src={previewImage} preview={false} />
      </Modal>
    </>
  );
};

export default UploadVehiclePhotos;
